import { useTranslation } from 'react-i18next'

import { useInlineNotifications } from '../../../../../hooks'
import { useCloseConfirm } from '../../../../Form'
import { FormikForm } from '../../../../Formik'
import { WidgetFormContainer } from '../../../../Widget'
import { getRequestProfileWidgetSideWorkersPayload } from '../RequestProfileWidgetSideWorkers.utils'

import { getRequestProfileWidgetSideWorkersFormValidationSchema } from './RequestProfileWidgetSideWorkersForm.utils'
import { RequestProfileWidgetSideWorkersFormFields } from './RequestProfileWidgetSideWorkersFormFields'

function RequestProfileWidgetSideWorkersForm({
  initialValues,
  modal,
  requestId,
  onClose,
  onSubmit,
  onSuccess,
}) {
  const { t } = useTranslation()

  const { handleClose, isCloseConfirm, setCloseConfirm } = useCloseConfirm({
    onClose,
  })

  const { handleAddNotification, handleRemoveNotification, notifications } =
    useInlineNotifications()

  const validationSchema =
    getRequestProfileWidgetSideWorkersFormValidationSchema(initialValues, t)

  async function handleSubmit(values, formikHelpers) {
    return onSubmit({
      payload: getRequestProfileWidgetSideWorkersPayload(values),
    })
      .then(() => {
        onSuccess?.()
      })
      .finally(() => {
        formikHelpers.setSubmitting(false)
      })
  }

  return (
    <FormikForm
      Container={WidgetFormContainer}
      containerProps={{
        isCloseConfirm,
        modal,
        setCloseConfirm,
        onClose,
      }}
      initialValues={initialValues}
      validateOnBlur={false}
      validateOnChange={false}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      <RequestProfileWidgetSideWorkersFormFields
        notifications={notifications}
        requestId={requestId}
        onCancel={handleClose}
        onRemoveNotification={handleRemoveNotification}
        onSetNotification={handleAddNotification}
      />
    </FormikForm>
  )
}

export default RequestProfileWidgetSideWorkersForm
